import { pub } from "../lib/pubThemeClasses";

export default function SectionHeader({ eyebrow, title, description, align = "left" }) {
  const alignClasses = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignClasses} mb-14 md:mb-20`}>
      {eyebrow && (
        <div className="font-mono text-xs uppercase tracking-[0.2em] text-[#FF4F00] mb-4 flex items-center gap-3">
          <span className="w-8 h-px bg-[#FF4F00]" />
          {eyebrow}
        </div>
      )}
      <h2 className={`font-sans text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight leading-tight ${pub.heroHeading}`}>
        {title}
      </h2>
      {description && (
        <p className={`mt-5 font-sans text-base md:text-lg leading-relaxed max-w-2xl ${pub.muted}`}>
          {description}
        </p>
      )}
    </div>
  );
}
